// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-container[data-v-600651b9]{scrollbar-width:none}.carousel-container[data-v-600651b9]::-webkit-scrollbar{display:none}@media screen and (min-width:1280px){.carousel-container[data-v-600651b9]{scroll-snap-type:x mandatory}.carousel-slide[data-v-600651b9]{scroll-snap-align:start}}.fade-enter-active[data-v-600651b9],.fade-leave-active[data-v-600651b9]{transition:opacity .15s ease}.fade-enter[data-v-600651b9],.fade-leave-to[data-v-600651b9]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
